import { Button, ButtonType } from '@resurs-internal/styx-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../common/utils'
import {
  DocViewerModal,
  docOpensInViewer,
  useDocViewer,
} from './DocViewerModal'
import styles from './Mock.module.scss'
import { useIsInternal } from './useIsInternal'
import { UseRealServiceButton } from './UseRealServiceButton'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

const getApplicantType = taskId => {
  switch (+taskId) {
    case 1:
      return 'MAIN_APPLICANT'
    case 2:
      return 'CO_APPLICANT'
    default:
      return null
  }
}

export const MockSign = () => {
  const { token } = useParams()
  const { taskId, signerIndex, altUrl } = useQuery()
  const [session, setSession] = useState(null)
  const [docs, setDocs] = useState([])
  const { previewDoc, openDoc, closeDoc } = useDocViewer()
  const isInternal = useIsInternal()

  const applicantType = getApplicantType(taskId)

  useEffect(() => {
    if (!token) return
    fetch(`${proxyPath}/checkpoint-romeo-signing/${token}/status`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (data) setSession(data)
      })
      .catch(console.error)

    fetch(`${proxyPath}/checkpoint-romeo-signing/${token}/documents`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : []))
      .then(setDocs)
      .catch(console.error)
  }, [token])

  const buildSignUrl = result => {
    let url = `${proxyPath}/mock/doSign?resursToken=${encodeURIComponent(token)}&result=${result}`
    if (taskId) url += `&taskId=${encodeURIComponent(taskId)}`
    if (signerIndex) url += `&signerIndex=${encodeURIComponent(signerIndex)}`
    return url
  }

  const doSignicat = () => {
    let url = `${proxyPath}/mock/signToSignicat?resursToken=${encodeURIComponent(token)}`
    if (taskId) url += `&taskId=${encodeURIComponent(taskId)}`
    if (signerIndex) url += `&signerIndex=${encodeURIComponent(signerIndex)}`
    window.location.href = url
  }

  return (
    <>
      <h1>Sign agreement</h1>
      {applicantType && <p>{applicantType.replace('_', ' ')}</p>}

      {session?.signers?.length > 0 && (
        <div className={styles.infoSection}>
          <div className={styles.sectionLabel}>Signers</div>
          {session.signers.map(s => (
            <div key={s.governmentId || s.name} className={styles.listItem}>
              <span>{s.name || 'Unknown'}</span>
              {s.governmentId && (
                <span className={styles.meta}>{s.governmentId}</span>
              )}
              <span className={styles.badge}>{s.status}</span>
            </div>
          ))}
        </div>
      )}

      {docs.length > 0 && (
        <div className={styles.infoSection}>
          <div className={styles.sectionLabel}>Documents</div>
          {docs.map(d => {
            const url = `${proxyPath}/checkpoint-romeo-signing/${token}/documents/${d.index}`
            return (
              <div key={d.index} className={styles.listItem}>
                <span>
                  {d.contentType?.includes('PDF') ? 'PDF' : 'Document'}
                  {d.type === 'VIEW' ? ' (view only)' : ''}
                </span>
                <span className={styles.meta}>{d.source}</span>
                {docOpensInViewer(d.contentType) ? (
                  <button
                    type="button"
                    className={styles.docLink}
                    onClick={() => openDoc({ doc: d, url })}
                  >
                    Open
                  </button>
                ) : (
                  <a href={url} download className={styles.docLink}>
                    Download
                  </a>
                )}
              </div>
            )
          })}
        </div>
      )}

      {session?.documentText && docs.length === 0 && (
        <div className={styles.documentText}>{session.documentText}</div>
      )}

      <div className={styles.lineWrapper}>
        <Button
          id="successButtonId"
          fullWidth
          onClick={() => {
            window.location.href = buildSignUrl('COMPLETE')
          }}
        >
          Sign
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="failureButtonId"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => {
            window.location.href = buildSignUrl('CANCELLED')
          }}
        >
          Cancel
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        {altUrl ? (
          <Button
            id="altMockButtonId"
            fullWidth
            outline
            type={ButtonType.Secondary}
            onClick={() => {
              window.location.href = decodeURIComponent(altUrl)
            }}
          >
            Review
          </Button>
        ) : (
          token && (
            <Button id="signicatButtonId" fullWidth onClick={doSignicat}>
              Use Signicat
            </Button>
          )
        )}
      </div>
      {isInternal && token && (
        <UseRealServiceButton
          apiPath={`${proxyPath}/checkpoint-romeo-signing/${token}/use_real_service`}
        />
      )}
      {previewDoc && (
        <DocViewerModal
          doc={previewDoc.doc}
          url={previewDoc.url}
          onClose={closeDoc}
        />
      )}
    </>
  )
}
